import {fetchGet} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const findVenueBuyPackages = (
    venueId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/user/venue/" + venueId + "/buy/packages",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findVenueDancePackages = (
    venueId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/user/venue/" + venueId + "/dance/packages",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findVenueDrinkPackages = (
    venueId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/user/venue/" + venueId + "/drink/packages",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findVenueSellPackages = (
    venueId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/sell/packages",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findVenueSellDancePackages = (
    venueId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/sell/dance/packages",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findVenueSellDrinkPackages = (
    venueId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/sell/drink/packages",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};